import owd from 'owd/owd';

export default class Video extends owd.Component {
	init() {
        this.$playbtn = this.$element.find('button, [data-video-play]');
        this.$video = this.$element.find('video');
        this.playing = false;

        this.bind();
	}

	bind() {
        this.on('click', this.$playbtn, () => {
            this.$video[0].play();
            this.$playbtn.fadeOut();
            this.$video.css('cursor', 'pointer');
            this.playing = true;
        });

        this.on('click', this.$video, () => {
            if (this.playing == true) {
                this.$video[0].pause();
                this.$playbtn.fadeIn();
                this.$video.css('cursor', '');
                this.playing = false;
            }
        })

    }

    destroy() {
        super.destroy();
    }
}

owd.registerComponent('video', {
	component: Video
});
